var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
const INTERACTIVE_SELECTOR = "a, button, input, select, textarea, label, [data-no-navigate]";
export default class paragraph_navigate_controller_default extends Controller {
  navigate(event) {
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;
    if (!this.hasUrlValue) return;
    window.location = this.urlValue;
  }
  keyNavigate(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;
    event.preventDefault();
    if (this.hasUrlValue) window.location = this.urlValue;
  }
}
__publicField(paragraph_navigate_controller_default, "values", { url: String });
